"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Color = require("color");
var common_1 = require("docs/common");
var components_1 = require("components");
var styles_1 = require("styles");
var componentStyle = {
    base: {
        color: styles_1.FontColor.White,
        backgroundColor: '#3498db',
        ':active': {
            backgroundColor: Color('#3498db').darken(.2).rgb().string(),
        },
    },
};
var description = 'You can style it as well.';
var code = "import React from 'react';\nimport { Button } from 'jsc-react-ui';\n\nconst style = {\n  color: '#f8f8f8',\n  backgroundColor: '#3498db',\n\n  ':active': {\n    backgroundColor: '#207ab6',\n  },\n};\n\nconst AppBarExample = () => <Button style={style} />;";
exports.StylingExampleButton = function () { return (React.createElement(common_1.Example, { title: "Styling", description: description, code: code },
    React.createElement(components_1.Button, { style: componentStyle.base }))); };
exports.StylingExampleButton.displayName = 'StylingExampleButton';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentButtonPage/StylingExampleButton.tsx
// module id = 637
// module chunks = 0